import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { CAN_VIEW_SECURITY } from '../../../constants';

type UseSecurityInsightsAgents = {
  clusterIds: string[];
  enabled?: boolean;
};

const SECURITY_AGENT_STATUSES_QUERY_KEY = 'security-agent-statuses';

export const getSecurityInsightsAgentsQueryKey = (clusterIds?: string[]) =>
  clusterIds
    ? ([SECURITY_AGENT_STATUSES_QUERY_KEY, clusterIds] as const)
    : ([SECURITY_AGENT_STATUSES_QUERY_KEY] as const);

const getSecurityInsightsAgentsQueryOptions = ({
  clusterIds,
  enabled = true,
}: UseSecurityInsightsAgents) =>
  queryOptions({
    queryKey: getSecurityInsightsAgentsQueryKey(clusterIds),
    queryFn: async () => {
      // Note: setHasEnabledSecurityAgents is called by the security-insights middleware
      const { data } = await apiClient.securityInsights.getAgentsStatuses({
        body: { clusterIds },
      });
      return data;
    },
    enabled: enabled && CAN_VIEW_SECURITY(),
  });

export const useSecurityInsightsAgents = (
  params: UseSecurityInsightsAgents
) => {
  const {
    data: agentsData,
    isLoading,
    error,
    refetch,
  } = useQuery(getSecurityInsightsAgentsQueryOptions(params));
  return { agentsData, isLoading, error, refetch };
};
